// extracted by mini-css-extract-plugin
export default {"switch":"HyTweh","active":"F_kYHv","handle":"CHKmKb","size-30":"KnUNCi"};